import ElakayImage from '../../../components/images/ElakayImage';
import React from 'react'
import { toImageUrl } from "../../../config";
import imgProductLakay from '../../Layout/imgs/md3.jpg'

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["thmbsSlider"]?.[key] || fallback;

export const Thumb = (props) => {
  const { selected, imgSrc, index, onClick, infoSource, alt } = props
  __setElakayInfoSource(infoSource);

  const originalSrc = toImageUrl(imgSrc)

  return (
    <div
      className={'embla-thumbs__slide'.concat(
        selected ? ' embla-thumbs__slide--selected' : ''
      )}
    >
      <button
        onClick={onClick}
        className="embla-thumbs__slide__button"
        type="button"
        aria-current={selected ? "true" : undefined}
        aria-label={alt || __elakayText("t001", `Image ${index + 1}`)}
      >
        <ElakayImage
          preset="product-thumb"
          fallback={imgProductLakay}
          className="embla-thumbs__slide__img"
          src={originalSrc}
          alt=""
          loading="lazy"
          decoding="async"

        />
      </button>
    </div>
  )
}
